import { API_BASE_URL_ENV } from "../jsx/common/common";
import BaseService from "./BaseService";

const apiEndpoint = API_BASE_URL_ENV() + "/home/header";

export default class HomeHeaderService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
